document.addEventListener("DOMContentLoaded", () => {
  let bundleUpdateRunning = false;

  function getRootRoute() {
    return window.Shopify?.routes?.root || "/";
  }

  async function getCart() {
    const response = await fetch(
      `${getRootRoute()}cart.js`,
      {
        headers: {
          "Accept": "application/json"
        }
      }
    );

    if (!response.ok) {
      throw new Error(
        "The cart could not be loaded."
      );
    }

    return response.json();
  }

  async function updateBundleQuantities(
    bundleId,
    quantity
  ) {
    if (!bundleId || bundleUpdateRunning) {
      return;
    }

    bundleUpdateRunning = true;

    try {
      const cart = await getCart();
      const updates = {};

      cart.items.forEach(item => {
        const itemBundleId =
          item.properties?.["_Hat Bundle ID"];

        if (itemBundleId === bundleId) {
          updates[item.key] = quantity;
        }
      });

      if (!Object.keys(updates).length) {
        return;
      }

      const response = await fetch(
        `${getRootRoute()}cart/update.js`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({
            updates
          })
        }
      );

      if (!response.ok) {
        const data = await response.json();

        throw new Error(
          data.description ||
          data.message ||
          "The cart could not be updated."
        );
      }

      /*
       * Reloading is the most reliable way to make Dawn
       * redraw totals, discounts, and the cart drawer.
       */
      window.location.reload();
    } catch (error) {
      console.error(
        "Hat bundle quantity update failed:",
        error
      );

      window.alert(
        "The customized hat quantity could not be updated. Please try again."
      );
    } finally {
      bundleUpdateRunning = false;
    }
  }

  document.addEventListener(
    "change",
    event => {
      const quantityInput = event.target.closest(
        'input[name="updates[]"], ' +
        ".quantity__input"
      );

      if (!quantityInput) return;

      const cartItem = quantityInput.closest(
        "[data-hat-bundle-id]"
      );

      if (!cartItem) return;

      const bundleId =
        cartItem.dataset.hatBundleId;

      if (!bundleId) return;

      const quantity = Math.max(
        0,
        parseInt(quantityInput.value, 10) || 0
      );

      event.preventDefault();
      event.stopImmediatePropagation();

      updateBundleQuantities(
        bundleId,
        quantity
      );
    },
    true
  );

  document.addEventListener(
    "click",
    event => {
      const removeButton = event.target.closest(
        "[data-hat-bundle-remove]"
      );

      if (!removeButton) return;

      const cartItem = removeButton.closest(
        "[data-hat-bundle-id]"
      );

      const bundleId =
        cartItem?.dataset.hatBundleId;

      if (!bundleId) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      updateBundleQuantities(
        bundleId,
        0
      );
    },
    true
  );
});